import React, { useEffect, useRef, useState } from "react";
import { onSaveFeedback } from "./saveFeedback";

function nextToastId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function SaveFeedbackHost() {
  const [toasts, setToasts] = useState([]);
  const [showSavingToast, setShowSavingToast] = useState(false);
  const batchRef = useRef({
    active: false,
    pendingCount: 0,
    hasError: false,
    errorMessage: "",
    finalizeTimer: null
  });

  useEffect(() => {
    function queueToast(kind, message) {
      const id = nextToastId();
      setToasts((prev) => [...prev, { id, kind, message }]);
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, 3200);
    }

    function finalizeBatch() {
      const batch = batchRef.current;
      if (!batch.active || batch.pendingCount !== 0) return;

      setShowSavingToast(false);
      if (batch.hasError) {
        queueToast("error", batch.errorMessage || "Save failed.");
      } else {
        queueToast("success", "Saved successfully.");
      }

      batch.active = false;
      batch.pendingCount = 0;
      batch.hasError = false;
      batch.errorMessage = "";
      batch.finalizeTimer = null;
    }

    return onSaveFeedback((detail) => {
      const batch = batchRef.current;

      if (detail.phase === "start") {
        if (batch.finalizeTimer) {
          window.clearTimeout(batch.finalizeTimer);
          batch.finalizeTimer = null;
        }

        if (!batch.active) {
          batch.active = true;
          batch.pendingCount = 0;
          batch.hasError = false;
          batch.errorMessage = "";
          setShowSavingToast(true);
        }

        batch.pendingCount += 1;
        return;
      }

      if (!batch.active) return;

      batch.pendingCount = Math.max(0, batch.pendingCount - 1);

      if (detail.phase === "error") {
        batch.hasError = true;
        batch.errorMessage = detail.message || "Save failed.";
      }

      if (batch.pendingCount === 0) {
        batch.finalizeTimer = window.setTimeout(finalizeBatch, 350);
      }
    });
  }, []);

  return (
    <div className="save-feedback-stack" aria-live="polite" aria-atomic="false">
      {showSavingToast ? (
        <div className="save-toast save-toast--loading" role="status">
          <span className="btn-auth-spinner save-toast__spinner" aria-hidden />
          <span>Saving...</span>
        </div>
      ) : null}
      {toasts.map((toast) => (
        <div key={toast.id} className={`save-toast save-toast--${toast.kind}`} role="status">
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}
